import { RouteRecordRaw } from 'vue-router';

const redirectRouter: RouteRecordRaw = {
    path: '/redirect',
    name: 'redirect',
    component: () => import('../views/Global/RedirectView.vue'),
    meta: {
        title: 'REDIRECT',
    },
};

export default redirectRouter;
